var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	27917: () => (loadStrictVersion("default", "@medflex/shared-types", false, [1,1,40,0], () => (__webpack_require__.e(4406).then(() => (() => (__webpack_require__(54406))))))),
	7676: () => (loadSingletonVersion("default", "react-dom", true, [4,18,2,0], () => (() => (__webpack_require__(45600))))),
	12590: () => (loadStrictVersion("default", "@tanstack/react-query", false, [1,5,56,2], () => (__webpack_require__.e(4302).then(() => (() => (__webpack_require__(44302))))))),
	64: () => (loadStrictVersion("default", "lodash", false, [4,4,17,21], () => (__webpack_require__.e(4810).then(() => (() => (__webpack_require__(54810))))))),
	12019: () => (loadStrictVersion("default", "qs", false, [1,6,11,0], () => (Promise.all([__webpack_require__.e(4282), __webpack_require__.e(7208)]).then(() => (() => (__webpack_require__(4282))))))),
	33690: () => (loadStrictVersion("default", "@tanstack/query-sync-storage-persister", false, [1,5,56,2], () => (__webpack_require__.e(5812).then(() => (() => (__webpack_require__(35812))))))),
	69814: () => (loadStrictVersion("default", "@tanstack/react-query-persist-client", false, [1,5,56,2], () => (__webpack_require__.e(1781).then(() => (() => (__webpack_require__(44162))))))),
	74188: () => (loadStrictVersion("default", "axios", false, [4,1,3,6], () => (__webpack_require__.e(4550).then(() => (() => (__webpack_require__(14550))))))),
	92948: () => (loadStrictVersion("default", "jotai", false, [1,1,9,0], () => (__webpack_require__.e(103).then(() => (() => (__webpack_require__(30103))))))),
	98548: () => (loadStrictVersion("default", "classnames", false, [4,2,2,6], () => (__webpack_require__.e(5286).then(() => (() => (__webpack_require__(25286))))))),
	4971: () => (loadStrictVersion("default", "react-router", false, [1,5,2,0], () => (Promise.all([__webpack_require__.e(8319), __webpack_require__.e(7138)]).then(() => (() => (__webpack_require__(7138))))))),
	92784: () => (loadStrictVersion("default", "jotai", false, [1,1,9,0], () => (__webpack_require__.e(923).then(() => (() => (__webpack_require__(10923))))))),
	80686: () => (loadStrictVersion("default", "@headlessui/react", false, [1,1,7,0], () => (__webpack_require__.e(1530).then(() => (() => (__webpack_require__(71530))))))),
	258: () => (loadStrictVersion("default", "date-fns", false, [1,1,30,1], () => (__webpack_require__.e(2686).then(() => (() => (__webpack_require__(32686))))))),
	10799: () => (loadStrictVersion("default", "@headlessui/react", false, [1,1,7,0], () => (__webpack_require__.e(2432).then(() => (() => (__webpack_require__(42432))))))),
	21456: () => (loadSingletonVersion("default", "react-i18next", true, [4,15,0,1], () => (() => (__webpack_require__(37446))))),
	25896: () => (loadStrictVersion("default", "yup", false, [4,0,32,11], () => (__webpack_require__.e(7394).then(() => (() => (__webpack_require__(17394))))))),
	32992: () => (loadSingletonVersion("default", "react-router-dom", false, [1,5,2,0], () => (Promise.all([__webpack_require__.e(8319), __webpack_require__.e(5064)]).then(() => (() => (__webpack_require__(15064))))))),
	35771: () => (loadStrictVersion("default", "classnames", false, [4,2,2,6], () => (__webpack_require__.e(727).then(() => (() => (__webpack_require__(50727))))))),
	43705: () => (loadStrictVersion("default", "i18next", false, [1,23,12,2], () => (__webpack_require__.e(5762).then(() => (() => (__webpack_require__(85762))))))),
	44420: () => (loadStrictVersion("default", "@medflex/shared-constants", false, [1,1,14,2], () => (__webpack_require__.e(8477).then(() => (() => (__webpack_require__(70858))))))),
	46392: () => (loadStrictVersion("default", "react-hook-form", false, [4,6,15,4], () => (__webpack_require__.e(2692).then(() => (() => (__webpack_require__(62692))))))),
	72058: () => (loadStrictVersion("default", "react-textarea-autosize", false, [4,8,3,4], () => (__webpack_require__.e(5574).then(() => (() => (__webpack_require__(83193))))))),
	73349: () => (loadStrictVersion("default", "@medflex/shared-utils", false, [1,1,16,9], () => (Promise.all([__webpack_require__.e(6164), __webpack_require__.e(3509)]).then(() => (() => (__webpack_require__(15890))))))),
	83274: () => (loadStrictVersion("default", "@medflex/gdt", false, [1,2,1,10], () => (__webpack_require__.e(3530).then(() => (() => (__webpack_require__(93530))))))),
	86901: () => (loadStrictVersion("default", "i18next", false, [1,23,12,2], () => (__webpack_require__.e(4552).then(() => (() => (__webpack_require__(64552))))))),
	90617: () => (loadStrictVersion("default", "@headlessui-float/react", false, [2,0,13,2], () => (__webpack_require__.e(3408).then(() => (() => (__webpack_require__(83408))))))),
	13216: () => (loadSingletonVersion("default", "react", true, [4,18,2,0], () => (() => (__webpack_require__(31681)))))
};
var initialConsumes = [13216];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"686": [
		80686
	],
	"1544": [
		64,
		12019,
		33690,
		69814,
		74188,
		92948,
		98548
	],
	"2590": [
		12590
	],
	"2784": [
		92784
	],
	"4433": [
		258,
		10799,
		21456,
		25896,
		32992,
		35771,
		43705,
		44420,
		46392,
		72058,
		73349,
		83274,
		86901,
		90617
	],
	"4971": [
		4971
	],
	"7676": [
		7676
	],
	"7917": [
		27917
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}